import { type BaseSchema, object, string } from "yup";

import type { QueryView } from "~/models/dto";

import { descriptionValidation, identifierValidation } from "../../react/setting-node/forms/form-validations";

export const viewValidationSchema: BaseSchema<Partial<QueryView>> = object().shape({
	name: string().label("View name").trim().required("required field"),
	description: descriptionValidation,
	identifier: identifierValidation,
});
